import React from "react";
import ModalComponent from "../../../../features/ModalComponent";
import { Assort } from "../../../models/Assort";
import { TicketAccess } from "../../../models/TicketAccess";
import { Exercise } from "../../../models/Exercise";

interface IProps {
  exercise: Exercise;
  onClose: () => void;
  tickets: Assort[];
  ticketAccess: TicketAccess;
}

const SingleExerciseTicketModal: React.FC<IProps> = ({ exercise, onClose, tickets, ticketAccess }) => {
  return (
    <div className="schedule-modal-info">
      <ModalComponent
        footer={false}
        open
        leftType="exercise"
        leftTitle={`${exercise.zone.displayName}`}
        leftImage={`${exercise.eventMessage}`}
        closeModal={onClose}
        title={exercise.name}
        ticketLists={tickets}
        onAccept={() => {}}
        ticketAccess={ticketAccess}
        exercise={exercise}
      >
        <article dangerouslySetInnerHTML={{ __html: exercise.description }}></article>
      </ModalComponent>
    </div>
  );
};

export default SingleExerciseTicketModal;
